import Vue from "vue";

const state = {
	admininvoices_options: {
		page: 1,
		itemsPerPage: null,
		sortBy: ["date"],
		sortDesc: [true],
		groupBy: [],
		groupDesc: [],
		mustSort: false,
		multiSort: false,
		search: null,
		date_start: null,
		date_end: null,
		datefiltertype: "currentyear",
	},
	admininvoices: {},
	_admininvoices_loading: 0,
	showCreateEditAdminInvoices: false,
	currentAdminInvoices: {},
	_admininvoices_exporting: 0,
	_admininvoices_importing: 0,
	showImportAdminInvoices: false,
	readedAdminInvoicesImport: null,
};

const getters = {
	getAdminInvoicesOptions: (state) => state.admininvoices_options,
	getAdminInvoices: (state) => state.admininvoices,
	admininvoices_loading: (state) => state._admininvoices_loading !== 0,
	showCreateEditAdminInvoices: (state) => state.showCreateEditAdminInvoices,
	getCurrentAdminInvoices: (state) => state.currentAdminInvoices,
	admininvoices_exporting: (state) => state._admininvoices_exporting !== 0,
	admininvoices_importing: (state) => state._admininvoices_importing !== 0,
	showImportAdminInvoices: (state) => state.showImportAdminInvoices,
	getReadedAdminInvoicesImport: (state) => state.readedAdminInvoicesImport,
};

const actions = {
	fetchAdminInvoices({ commit, dispatch }) {
		commit("START_ADMININVOICES_LOADING");
		axios
			.get("/api/admin/invoices", { params: state.admininvoices_options })
			.then((res) => {
				commit("setAdminInvoices", res.data);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_ADMININVOICES_LOADING");
			});
	},
	createAdminInvoices({ commit, dispatch }) {
		commit("START_ADMININVOICES_LOADING");
		if (!state.currentAdminInvoices.id) {
			return new Promise((resolve, reject) => {
				axios
					.post("/api/admin/invoices", state.currentAdminInvoices)
					.then((res) => {
						dispatch("handleResponseMessage", res.data);
						if (state.showCreateEditAdminInvoices) {
							dispatch("fetchAdminInvoices");
							dispatch("hideAction", "hideCreateEditAdminInvoices");
						}
						resolve(res.data);
					})
					.catch((err) => {
						dispatch("handleError", err);
						reject(err);
					})
					.then(function () {
						commit("STOP_ADMININVOICES_LOADING");
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				axios
					.put("/api/admin/invoices/" + state.currentAdminInvoices.id, state.currentAdminInvoices)
					.then((res) => {
						if (res.data.object) {
							dispatch("fetchAdminInvoices");
							dispatch("hideAction", "hideCreateEditAdminInvoices");
						}
						dispatch("handleResponseMessage", res.data);
						resolve(res.data);
					})
					.catch((err) => {
						dispatch("handleError", err);
						reject(err);
					})
					.then(function () {
						commit("STOP_ADMININVOICES_LOADING");
					});
			});
		}
	},
	deleteAdminInvoices({ commit, dispatch }, array_ids) {
		commit("START_ADMININVOICES_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.post("/api/admin/invoices/delete", { array_ids: array_ids })
				.then((res) => {
					dispatch("fetchAdminInvoices");
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_ADMININVOICES_LOADING");
				});
		});
	},
	exportAdminInvoices({ commit, dispatch }, type) {
		commit("START_ADMININVOICES_EXPORTING");
		axios
			.post("/api/admin/invoices/export-download", state.admininvoices_options, { responseType: "arraybuffer" })
			.then((res) => {
				dispatch("downloadFromResponse", res);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_ADMININVOICES_EXPORTING");
			});
	},
	importAdminInvoicesRead({ commit, dispatch }, formData) {
		commit("START_ADMININVOICES_IMPORTING");
		const source = axios.CancelToken.source();
		commit("setSource", source);
		commit("setProgress", { total: 100, loaded: 0 });
		return new Promise((resolve, reject) => {
			axios
				.post("/api/admin/invoices/import-read", formData, {
					cancelToken: source.token,
					onUploadProgress: (e) => {
						commit("setProgress", { total: e.total, loaded: e.loaded });
					},
				})
				.then((res) => {
					if (res.data) {
						commit("setReadedAdminInvoicesImport", res.data);
					}
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_ADMININVOICES_IMPORTING");
				});
		});
	},
	importAdminInvoicesStore({ commit, dispatch }, formData) {
		commit("START_ADMININVOICES_IMPORTING");
		const source = axios.CancelToken.source();
		commit("setSource", source);
		commit("setProgress", { total: 100, loaded: 0 });
		return new Promise((resolve, reject) => {
			axios
				.post("/api/admin/invoices/import-store", formData, {
					cancelToken: source.token,
					onUploadProgress: (e) => {
						// updating progress indicator
						commit("setProgress", { total: e.total, loaded: e.loaded });
					},
				})
				.then((res) => {
					if (res.data) {
						dispatch("hideAction", "hideImportAdminInvoices");
						dispatch("fetchAdminInvoices");
					}
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_ADMININVOICES_IMPORTING");
				});
		});
	},
};
const mutations = {
	setAdminInvoicesOptions(state, value) {
		Vue.set(state, "admininvoices_options", value);
	},
	setAdminInvoices(state, data) {
		Vue.set(state, "admininvoices", data);
	},
	START_ADMININVOICES_LOADING(state) {
		state._admininvoices_loading++;
	},
	STOP_ADMININVOICES_LOADING(state) {
		state._admininvoices_loading--;
	},
	showCreateEditAdminInvoices(state) {
		state.showCreateEditAdminInvoices = true;
	},
	hideCreateEditAdminInvoices(state) {
		state.showCreateEditAdminInvoices = false;
	},
	setCurrentAdminInvoices(state, value) {
		Vue.set(state, "currentAdminInvoices", value);
	},
	START_ADMININVOICES_EXPORTING(state) {
		state._admininvoices_exporting++;
	},
	STOP_ADMININVOICES_EXPORTING(state) {
		state._admininvoices_exporting--;
	},
	setReadedAdminInvoicesImport(state, value) {
		Vue.set(state, "readedAdminInvoicesImport", value);
	},
	START_ADMININVOICES_IMPORTING(state) {
		state._admininvoices_importing++;
	},
	STOP_ADMININVOICES_IMPORTING(state) {
		state._admininvoices_importing--;
	},
	showImportAdminInvoices(state) {
		state.showImportAdminInvoices = true;
	},
	hideImportAdminInvoices(state) {
		state.showImportAdminInvoices = false;
		Vue.set(state, "readedAdminInvoicesImport", null);
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
